import {
  ADD_NEW_TICKET,
  ADD_NEW_TICKET_SUCCESS,
  ADD_NEW_TICKET_FAIL,
  GETTING_TICKET_CONTENT_DATA,
  GETTING_TICKET_CONTENT_DATA_SUCCESS,
  GETTING_TICKET_CONTENT_DATA_FAILED,
  TICKET_DETAILS_LISTING_DATA,
  TICKET_DETAILS_LISTING_DATA_SUCCESS,
  TICKET_DETAILS_LISTING_DATA_FAILURE,
  TICKET_CITIES_SUGGESTION_DATA,
  TICKET_CITIES_SUGGESTION_DATA_SUCCESS,
  TICKET_CITIES_SUGGESTION_DATA_FAILURE,
} from "../Constants/ticketManagementConstant";

const initialState = {
  addNewTicketLoading: false,
  addNewTicketData: [],
  ticketContentDataLoading: false,
  ticketContentData: null,
  ticketManagementListingLoading: false,
  ticketManagementLisitingData: [],
  ticketCitiesSuggestionDataLoading: false,
  ticketCitiesSuggestionData: null,
};

export default function ticketManagementReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case ADD_NEW_TICKET:
      return {
        ...state,
        addNewTicketLoading: true,
      };
    case ADD_NEW_TICKET_SUCCESS:
      return {
        ...state,
        addNewTicketLoading: false,
        addNewTicketData: action.payload,
      };
    case ADD_NEW_TICKET_FAIL:
      return {
        ...state,
        addNewTicketLoading: false,
        addNewTicketData: [],
      };
    case GETTING_TICKET_CONTENT_DATA:
      return {
        ...state,
        ticketContentDataLoading: true,
      };
    case GETTING_TICKET_CONTENT_DATA_SUCCESS:
      return {
        ...state,
        ticketContentDataLoading: false,
        ticketContentData: action.payload,
      };
    case GETTING_TICKET_CONTENT_DATA_FAILED:
      return {
        ...state,
        ticketContentDataLoading: false,
        ticketContentData: null,
      };
    case TICKET_DETAILS_LISTING_DATA:
      return {
        ...state,
        ticketManagementListingLoading: true,
      };
    case TICKET_DETAILS_LISTING_DATA_SUCCESS:
      return {
        ...state,
        ticketManagementListingLoading: false,
        ticketManagementLisitingData: action.payload,
      };
    case TICKET_DETAILS_LISTING_DATA_FAILURE:
      return {
        ...state,
        ticketManagementListingLoading: false,
        ticketManagementLisitingData: [],
      };

    case TICKET_CITIES_SUGGESTION_DATA:
      return {
        ...state,
        ticketCitiesSuggestionDataLoading: true,
      };
    case TICKET_CITIES_SUGGESTION_DATA_SUCCESS:
      return {
        ...state,
        ticketCitiesSuggestionDataLoading: false,
        ticketCitiesSuggestionData: action.payload,
      };
    case TICKET_CITIES_SUGGESTION_DATA_FAILURE:
      return {
        ...state,
        ticketCitiesSuggestionDataLoading: false,
        ticketCitiesSuggestionData: null,
      };

    default:
      return state;
  }
}
